import { resolveReadableHttpErrorMessage } from "../../../lib/http/errors";
import type { CustomerWorkbenchListFilters } from "../types";

/** 归一化客户工作台筛选条件。 */
export function normalizeCustomerWorkbenchFilters(
  filters: CustomerWorkbenchListFilters,
): CustomerWorkbenchListFilters {
  return {
    regionSchoolText: normalizeOptionalText(filters.regionSchoolText),
    customerName: normalizeOptionalText(filters.customerName),
    salesUserId: filters.salesUserId,
    salesUserName: filters.salesUserId
      ? normalizeOptionalText(filters.salesUserName) ?? "已选销售"
      : undefined,
    primaryOwnerUserId: filters.primaryOwnerUserId,
    sharedOwnerUserId: filters.sharedOwnerUserId,
    isDisabled: filters.isDisabled,
    nlQuery: normalizeOptionalText(filters.nlQuery),
  };
}

/** 格式化客户所属销售名称。 */
export function formatCustomerOwners(names: string[]) {
  return names.length ? names.join("、") : "未分配";
}

/** 合并客户地区展示文本。 */
export function formatCustomerArea(province?: string, city?: string) {
  return [province, city].filter(Boolean).join(" / ") || "-";
}

/** 归一化客户工作台运行时错误。 */
export function formatCustomerWorkbenchError(error: unknown, fallback: string) {
  return resolveReadableHttpErrorMessage(error, fallback, {
    conflictCode: "CRM_CUSTOMER_NAME_CONFLICT",
    conflictFallback: "客户名称已存在，请勿重复新增。",
    opaqueConflictDetails: ["crm-customer-name-conflict"],
    validationFallback: "请完整填写客户必填项后再保存。",
  });
}

/** 格式化销售下拉显示。 */
export function formatCustomerStaffOptionLabel(option: {
  displayName: string;
  username: string;
  phone?: string;
  id: number;
}) {
  const name = option.displayName.trim() || option.username.trim() || `用户${option.id}`;
  return [name, option.phone].filter(Boolean).join(" · ");
}

/** 归一化可选筛选文本。 */
function normalizeOptionalText(value?: string) {
  const normalized = value?.trim();
  return normalized ? normalized : undefined;
}
